export interface FirstRunGuidanceConfig {
  readonly growthHintTimeoutMs: number;
}

export const firstRunGuidanceConfig = {
  growthHintTimeoutMs: 6_000,
} as const satisfies FirstRunGuidanceConfig;
